module.exports = __webpack_public_path__ + "static/media/going-places.04747f05.svg";